<template>
    <div class="nheader">
        <img class="hbg" src="@/assets/newscreen/top.gif" alt="">
        <div class="timemodule">
            <div class="time">{{ time }}</div>
            <div class="line"></div>
            <div class="dm">
                <div class="day">{{ day }}</div>
                <div class="yyyymmdd">{{ date }}</div>
            </div>
        </div>
        <slot></slot>
    </div>
</template>

<script>
import {timeStamp} from '@/util/common/date';

export default {
    data() {
        return {
            time: "",
            day: "",
            date: "",
            timer: null
        }
    },
    created() {
        this.getDate();
        this.timer = setInterval(() => {
            this.getDate()
        }, 1000)
    },
    destroyed() {
        clearInterval(this.timer)   
    },
    methods: {
        getDate() {
            let datestr = timeStamp(Date.now(), "yyyy/MM/dd HH:mm:ss");
            this.time = datestr.substring(11);
            this.date = datestr.substring(0, 10);
            let day = new Date().getDay();
            let week = ["星期天", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
            this.day = week[day];
        }
    }
}
</script>

<style lang="scss" scoped>
.nheader {
    width: 100%;
    position: relative;
    line-height: 1;
    .hbg {
        width: 100%;
    }
    .timemodule {
        position: absolute;
        right: 2rem;
        top: 2.2rem;
        display: flex;
        align-items: center;
        .time {
            color: #fff;
        }
        .line {
            margin: 0 0.5rem;
            width: 0.0625rem;
            height: 0.5rem;
            background: #fff;//2333;
        }
        .dm {
            color: #fff;//2333;
            font-size: 0.75rem;
            text-align: left;
            .day {
                margin-bottom: 0.25rem;
            }
            .yyyymmdd {

            }
        }
    }
}
</style>